export const messages = {
  title: { id: 'admin/promotions.form.conditions.marketing-tags.title' },
  editor: {
    description: {
      id: 'admin/promotions.form.conditions.marketing-tags.editor.description',
    },
    moreInformation: {
      id: 'admin/promotions.links.conditions.marketing-tags.more-information',
    },
    equals: {
      id: 'admin/promotions.form.utils.equals-to',
    },
    different: {
      id: 'admin/promotions.form.utils.different-from',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.conditions.marketing-tags.view.title',
    },
  },
}
